<template>
    <div>
        <MenuProducts/>
        <Product_stock/>
    </div>
</template>

<script>
    import MenuProducts from "@/components/admin/manage_products/menuproducts/MenuProducts.vue";
    import Product_stock from "@/components/admin/manage_products/Product_stock.vue";
    export default {
        name: "MainProduct",
        components: {
            Product_stock,
            MenuProducts
        }
    }
</script>

<style scoped>

</style>
